import { useEffect, useState } from 'react'
import { Modal } from 'medere-ui-framework'
import { Calendar } from 'primereact/calendar'

interface BulkCloseContractHonorariumModalProps {
  visible: boolean
  count: number
  confirming: boolean
  onCancel: () => void
  onConfirm: (closeDate: Date) => void
}

const CLOSE_DATE_REQUIRED = 'Completá la fecha de cierre'
const CLOSE_DATE_BEFORE_TODAY = 'Ingresá una fecha de cierre igual o posterior a hoy'

function today(): Date {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), now.getDate())
}

function validate(closeDate: Date | null): string | undefined {
  if (!closeDate) return CLOSE_DATE_REQUIRED
  if (closeDate < today()) return CLOSE_DATE_BEFORE_TODAY
  return undefined
}

export default function BulkCloseContractHonorariumModal({
  visible,
  count,
  confirming,
  onCancel,
  onConfirm,
}: Readonly<BulkCloseContractHonorariumModalProps>) {
  const [closeDate, setCloseDate] = useState<Date | null>(today)
  const [error, setError] = useState<string | undefined>()

  useEffect(() => {
    if (!visible) return
    setCloseDate(today())
    setError(undefined)
  }, [visible])

  function confirm() {
    const found = validate(closeDate)
    setError(found)
    if (!found && closeDate) onConfirm(closeDate)
  }

  return (
    <Modal
      visible={visible}
      setVisible={(nextVisible) => {
        if (!nextVisible) onCancel()
      }}
      header={<span className='chd-modal-title'>Agregar fecha de cierre</span>}
      width='w-medium'
      className='chd-modal'
      footerButtonLeftText='Cancelar'
      onClickLeftBtn={onCancel}
      footerButtonRightText='Agregar fecha de cierre'
      onClickRightBtn={confirm}
      rightButtonDisabled={confirming}
    >
      <div className='chd-modal-body'>
        <p className='chd-confirm-text'>
          Se va a agregar la misma fecha de cierre a <strong>{count}</strong> contratos. Las futuras y las
          que ya terminan antes de esa fecha no se modifican.
        </p>
        <div className='chd-field'>
          <label htmlFor='chd-bulk-close-date'>
            Fecha de cierre <span className='md-req'>*</span>
          </label>
          <Calendar
            inputId='chd-bulk-close-date'
            value={closeDate}
            dateFormat='dd/mm/yy'
            showIcon
            minDate={today()}
            placeholder='dd/mm/aaaa'
            appendTo={document.body}
            className={error ? 'p-invalid' : ''}
            onChange={(event) => {
              const value = event.value instanceof Date ? event.value : null
              setCloseDate(value)
              if (error) setError(validate(value))
            }}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? 'chd-bulk-close-date-error' : undefined}
          />
          {error && (
            <small id='chd-bulk-close-date-error' className='chd-field-error'>
              <i className='pi pi-exclamation-triangle' aria-hidden='true' />
              {error}
            </small>
          )}
        </div>
      </div>
    </Modal>
  )
}
